import api from './utilPartner';

const controller = 'AgendaRecebivelParcela';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  ListarPorAgenda: function (dto) {
    return api.Axios.GetParams(url + '/ListarPorAgenda', dto);
  },
});
